import moment from 'moment'
import React, { FC } from 'react'

//* styles
import {
  FeaturedListingOuter,
  ListingContainerBottomSection,
  ListingContainerLeftSection,
  ListingContainerRightSection,
  ListingContainerTopButtons,
  ListingContainerTopDropDowns,
  ListingContainerTopSection,
  PaginationContainer,
} from '../style'

//* utils
import { OPTIONS } from '../../../../../../constants/dateOptions'
import { getMicrocopies, getPageNumber } from '../utils/get'

//* components
import Button from '../../../../../global/button'
import GlobalContainer from '../../../../../global/globalContainer'
import Pagination from '../../../../../global/pagination'
import Typography from '../../../../../global/typography'
import ListingItem from '../../listingItem'
import { handleYearChange } from '../utils/handle'
import { Select } from './select'

type Props = {
  featuredListings: any
  handleFilterItemClick: (type: string | null, year: string[] | null, wasClicked: boolean) => void
  listingPageData: any
  typeSelection: string
  listingYears: any
  yearSelection: any
  filteredListings: any
  start: number
  end: number
  locale: string
  pageContent: any
  hrefForPage: (page: number) => string
}

export const ListingPageContent: FC<Props> = ({
  featuredListings,
  handleFilterItemClick,
  listingPageData,
  typeSelection,
  listingYears,
  yearSelection,
  filteredListings,
  start,
  end,
  pageContent,
  hrefForPage,
}) => {
  const {
    LISTING_TYPES,
    financialNewsText,
    financialNewsLinkText,
    financialNewsLinkUrl,
    mobileYearFilterText,
  } = getMicrocopies(listingPageData.microcopy)

  const handlePaginationClick = (page: number) => {
    if (page > 1) {
      history.pushState(null, '', `/${listingPageData.slug}/${page}`)
    } else {
      history.pushState(null, '', `/${listingPageData.slug}`)
    }

    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <GlobalContainer>
      <FeaturedListingOuter $featuredListing={true}>{featuredListings}</FeaturedListingOuter>

      <ListingContainerTopSection>
        <ListingContainerTopButtons>
          {/* @ts-ignore */}
          {Object.values(LISTING_TYPES).map((type: string, index: number) => {
            return (
              <button
                onClick={() => handleFilterItemClick(type, null, true)}
                className={`Listing__Buttons-Styles ${
                  typeSelection.toLowerCase().split(' ').join('-') ===
                  type.toLocaleLowerCase().split(' ').join('-')
                    ? 'active'
                    : ''
                }`}
                key={`Listing__Buttons--${index}`}>
                <Typography type="label">{type}</Typography>
              </button>
            )
          })}
        </ListingContainerTopButtons>

        <ListingContainerTopDropDowns>
          <Select
            listingYears={listingYears}
            handleFilterItemClick={handleFilterItemClick}
            listingTypes={LISTING_TYPES}
            mobileYearFilterText={mobileYearFilterText}
            typeSelection={typeSelection}
            yearSelection={yearSelection}
          />
        </ListingContainerTopDropDowns>
      </ListingContainerTopSection>

      <ListingContainerBottomSection>
        <ListingContainerLeftSection>
          <Typography type="header6" className="Listing__Year-title">
            {listingPageData.microcopy.values[4]
              ? listingPageData.microcopy.values[4].value
              : 'Years'}
          </Typography>

          <div className="Listing__Year-Container">
            {listingYears.map((year: any, index: number) => {
              return (
                <label htmlFor={year} key={`listing_year--${index}`}>
                  <input
                    id={year}
                    type="checkbox"
                    value={year}
                    onChange={e =>
                      handleFilterItemClick(null, handleYearChange(e, yearSelection), true)
                    }
                    checked={yearSelection.includes(year)}
                  />

                  <Typography type="body" className="listing_year--option-text font__inter">
                    {year}
                  </Typography>
                </label>
              )
            })}
          </div>

          <div className="Financial_News-Block">
            <Typography type="bodyXS" className="financial_news-text font__inter">
              {financialNewsText}
            </Typography>

            <Button
              icon={true}
              href={financialNewsLinkUrl}
              text={financialNewsLinkText}
              type="text-link"
              size="small"
              theme={'light'}
            />
          </div>
        </ListingContainerLeftSection>

        <ListingContainerRightSection>
          {filteredListings.slice(start, end).map((listing: any, index: number) => {
            const listingData = {
              title: listing.title || listing.h1Title || '',
              date: listing.date || '',
              slug: listing.slug || '',
              url: listing.url1 || '',
              type: listing.articleType || LISTING_TYPES.MEDIA_COVERAGE,
              publication:
                (listing.metaInformation && listing.metaInformation[0]?.customerName) || '',
            }

            const date = new Date(listingData.date)
            let formattedDate = moment(date).utc().format('MMMM DD, YYYY')
            formattedDate = new Date(formattedDate).toLocaleDateString(pageContent.locale, OPTIONS)

            return (
              <ListingItem
                key={`ListItem--${listingData.slug}-${index}`}
                {...{
                  listingTitle: listingData.title,
                  listingSlug: listingData.slug,
                  listingUrl: listingData.url,
                  listingType: listingData.type,
                  listingPublication: listingData.publication,
                  formattedDate,
                }}
              />
            )
          })}

          <PaginationContainer>
            {filteredListings.length > pageContent.listingsPerPage && (
              <Pagination
                activePage={getPageNumber(pageContent.pageNumber)}
                hrefForPage={hrefForPage}
                handleClick={handlePaginationClick}
                numPagesBeforeEllipses={3}
                numResults={filteredListings.length}
                numResultsPerPage={pageContent.listingsPerPage}
              />
            )}
          </PaginationContainer>
        </ListingContainerRightSection>
      </ListingContainerBottomSection>
    </GlobalContainer>
  )
}
